export default "__VITE_ASSET__DZbtppxq__"